import React, { Component } from "react";
import { connect } from "react-redux";
import { fetchInfiniteMails } from "Thunks";
import {
  openMailViewer,
  resetMails,
  getGalleryItemsByType,
  setGalleryItems
} from "Actions";

import EboxComponent from "./EboxComponent";

class EboxContainer extends Component {
  state = {
    status: "RECEIVED",
    mediaType: "ALL"
  };

  componentDidMount() {
    const { fetchInfiniteMails } = this.props;

    fetchInfiniteMails({ status: this.state.status });
  }

  handleChangeStatus = (status, e) => {
    const { fetchInfiniteMails, resetMails } = this.props;

    this.setState({ status });

    resetMails();
    fetchInfiniteMails({ status });
  };

  loadMoreMails = () => {
    const { fetchInfiniteMails } = this.props;
    fetchInfiniteMails({ status: this.state.status });
  };

  handleChangeMediaType = mediaType => {
    const { getGalleryItemsByType, setGalleryItems, gallery } = this.props;
    setGalleryItems(gallery);
    this.setState({ mediaType });
    if (mediaType !== "ALL") {
      getGalleryItemsByType(mediaType);
    }
  };

  handleDisplayMail = mail => {
    const { openMailViewer } = this.props;

    openMailViewer({
      mails: [mail],
      isOpen: true,
      currentMail: mail
    });
  };

  render() {
    const { mails, hasMoreMails, fetching, fetched } = this.props;
    return (
      <EboxComponent
        mails={mails}
        hasMoreMails={hasMoreMails}
        fetching={fetching}
        fetched={fetched}
        getMailsByStatus={this.handleChangeStatus}
        loadMoreMails={this.loadMoreMails}
        status={this.state.status}
        getGalleryItemsByType={this.handleChangeMediaType}
        mediaType={this.state.mediaType}
        displayMailContent={this.handleDisplayMail}
      />
    );
  }
}
// Connected Component
const mapStateToProps = state => ({
  mails: state.ebox.mails.items,
  gallery: state.ebox.gallery.items,
  fetching: state.ebox.mails.fetching,
  hasMoreMails: state.ebox.mails.hasMoreItems,
  fetched: state.ebox.mails.fetched
});

const mapDispatchToProps = dispatch => ({
  fetchInfiniteMails: type => dispatch(fetchInfiniteMails(type)),
  setGalleryItems: items => dispatch(setGalleryItems(items)),

  getGalleryItemsByType: type => dispatch(getGalleryItemsByType(type)),
  resetMails: () => dispatch(resetMails()),
  openMailViewer: viewer => dispatch(openMailViewer(viewer))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EboxContainer);



// WEBPACK FOOTER //
// ./src/components/Community/Common/Ebox/EboxContainer.js